var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"simple-slider"},[_c('vue-slide-bar',{staticClass:"pt-3",model:{value:(_vm.simpleValue),callback:function ($$v) {_vm.simpleValue=$$v},expression:"simpleValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }